import { PlusCircleOutlined } from '@ant-design/icons';
import { ModalAlert } from '@molecules';
import { Button, Col, Collapse, Row } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import { TenantFormData } from 'src/features/tenants/types/tenantForm.types';

import { TenantFormSection } from '../formSection.types';
import { SettingsList } from './components/SettingsList';

const keyName = '_id';
export const SettingsForm: TenantFormSection = () => {
  const [activePanel, setActivePanel] = useState<
    string | string[] | undefined
  >();
  const [secretToDelete, setSecretToDelete] = useState<
    { index: number; id?: number } | undefined
  >(undefined);
  const { control, setValue, getValues } = useFormContext<TenantFormData>();
  const {
    append: appendSettings,
    remove: removeAddField,
    fields: addFields,
  } = useFieldArray({
    keyName,
    control,
    name: 'settings.add',
  });

  const { fields: editFields } = useFieldArray({
    keyName,
    control,
    name: 'settings.edit',
  });

  const handleDeleteEditSetting = useCallback((_: any, id?: number) => {
    if (!id) return;
    const toRemove = getValues('settings.delete') ?? [];
    toRemove.push(id);
    setValue('settings.delete', toRemove);
  }, []);

  const handleDeleteAddSetting = useCallback((index: number) => {
    removeAddField(index);
  }, []);

  const handleAppendNewSetting = useCallback(() => {
    appendSettings({
      configKeyContext: null,
      configKeyDescription: '',
      configKey: '',
      configValue: '',
      configType: null,
      encrypted: null,
      public: null,
    });
  }, []);

  useEffect(() => {
    if (addFields.length > 0)
      setActivePanel(addFields[addFields.length - 1]._id);
  }, [addFields.length]);

  return (
    <>
      <Collapse
        key={Date.now()}
        activeKey={activePanel}
        onChange={e => {
          setActivePanel(e as any);
        }}
        expandIconPosition='end'
        ghost
      >
        {SettingsList({
          settingField: 'edit',
          onDelete: (index, id) => setSecretToDelete({ index, id }),
          fields: editFields,
        }).map(EditSetting => EditSetting)}

        {SettingsList({
          settingField: 'add',
          onDelete: index => setSecretToDelete({ index }),
          fields: addFields,
        }).map(AddSetting => AddSetting)}
      </Collapse>
      <Row justify='center'>
        <Col>
          <Button
            type='text'
            style={{ color: '#177DDC' }}
            icon={<PlusCircleOutlined />}
            onClick={handleAppendNewSetting}
          >
            Adicionar Secret/Variável
          </Button>
        </Col>
      </Row>
      <ModalAlert
        showModal={Boolean(secretToDelete)}
        confirmButtonAction={() => {
          if (!secretToDelete) return;
          const { index, id } = secretToDelete;
          if (id) {
            handleDeleteEditSetting(index, id);
          } else {
            handleDeleteAddSetting(index);
          }
          setSecretToDelete(undefined);
        }}
        denyButtonAction={() => {
          setSecretToDelete(undefined);
        }}
        titleLabel={'Excluir Secret/Variável'}
        messageLabel='Tem certeza que deseja excluir essa secret/variável?'
      />
    </>
  );
};
